import { useCallback, useEffect, useRef } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';

import { AuthPath } from '../constants/path';

const useRedirectLogin = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const locationRef = useRef(location);

  const redirectLogin = useCallback(() => {
    navigate(AuthPath.Login, { state: { from: locationRef.current } });
  }, [navigate]);

  useEffect(() => {
    locationRef.current = location;
  }, [location]);

  return redirectLogin;
};

export default useRedirectLogin;
